import { render, staticRenderFns } from "./Trivia.vue?vue&type=template&id=69c8eaa2&scoped=true&"
import script from "./Trivia.vue?vue&type=script&lang=js&"
export * from "./Trivia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c8eaa2",
  null
  
)

export default component.exports